import PropTypes from "prop-types";
import { useState, useRef, useEffect } from "react";
import CTAs from "./CTAs";

const InvoiceReminderTemplate = ({ 
  className = "", 
  onClose, 
  onSave,
  onContentChange, // New prop to pass content back
  initialContent = null // Optional initial content
}) => {
  // Default content
  const defaultContent = `Hi [Contact First Name],

I hope this message finds you well. Our records indicate that the following invoice for products/services provided by [Company Name] is now overdue:

Invoice Number: [Invoice Number]
Due Date: [Due Date]
Outstanding Amount: [Amount Due]

We kindly request that you arrange payment of the invoice, however if you have already paid the invoice, please disregard this notice.

To view your bill visit [Online Invoice Link].

Should you have any queries or require further assistance, please do not hesitate to contact us at [Company Email] or [Company Phone]

Thanks
[Trading Name]`;

  const contentRef = useRef(null);
  const [content, setContent] = useState(initialContent || defaultContent);

  // Update content when the div content changes
  const handleContentChange = () => {
    if (contentRef.current) {
      const newContent = contentRef.current.innerHTML;
      setContent(newContent);
      
      if (onContentChange) {
        onContentChange(newContent);
      }
    }
  };

  // Handle save action
// Handle save action
const handleSave = () => {
  if (onSave) {
    onSave(content); // Pass the content to onSave
  }
  // You might also want to close the modal after saving
  if (onClose) {
    onClose();
  }
};

  return (
    <div
      className={`w-[672px] relative shadow-[0px_10px_60px_rgba(0,_0,_0,_0.1)] rounded-2xl bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-end justify-start max-w-full max-h-[90vh] overflow-auto text-left text-base text-neutrals-neutral-900 font-open-sans-font-family-meta-strong ${className}`}
    >
      <div className="self-stretch flex flex-col items-start justify-start gap-5">
        <div className="self-stretch flex flex-col items-start justify-start pt-6 px-6 pb-0 gap-4">
          <div className="self-stretch flex flex-row items-start justify-between gap-0">
            <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-lg bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-start p-3">
              <div className="w-6 relative h-6">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="m13.26 3.6-8.21 8.69c-.31.33-.61.98-.67 1.43l-.37 3.24c-.13 1.17.71 1.97 1.87 1.77l3.22-.55c.45-.08 1.08-.41 1.39-.75l8.21-8.69c1.42-1.5 2.06-3.21-.15-5.3-2.2-2.07-3.87-1.34-5.29.16Z"
                    stroke="#2d404e"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M11.89 5.05a6.126 6.126 0 0 0 5.45 5.15M3 22h18"
                    stroke="#2d404e"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="flex flex-row items-center justify-start p-2.5">
              <div className="w-6 relative h-6 overflow-hidden shrink-0">
                <img
                  className="absolute h-3/6 w-6/12 top-[25%] right-[25%] bottom-[25%] left-[25%] max-w-full overflow-hidden max-h-full"
                  alt=""
                  src="Vector.svg"
                />
                <img
                  className="absolute h-3/6 w-6/12 top-[25%] right-[25%] bottom-[25%] left-[25%] max-w-full overflow-hidden max-h-full"
                  alt=""
                  src="Vector.svg"
                />
              </div>
            </div>
          </div>
          <div className="w-[106px] flex flex-col items-start justify-start gap-0.5">
            <div className="self-stretch relative font-semibold">
              Edit reminder
            </div>
            <div className="self-stretch relative text-slategray-200">
              Description.
            </div>
          </div>
        </div>
       <div className="self-stretch flex flex-col items-start justify-start py-0 px-6 gap-3">
        <div className="flex flex-row items-center justify-start gap-3">
          <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-lg bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-start py-2 px-3 gap-1.5">
            <div className="w-[104px] flex flex-row items-center justify-start gap-2">
              <div className="w-5 relative h-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M2.67 7.17V5.35c0-1.15.93-2.07 2.07-2.07h14.52c1.15 0 2.07.93 2.07 2.07v1.82M12 20.72V4.11M8.06 20.72h7.88"
                    stroke="#2d404e"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="relative font-semibold">Inter</div>
            </div>
            <div className="w-4 relative h-4 overflow-hidden shrink-0">
              <img
                className="absolute h-[20.63%] w-[41.88%] top-[39.58%] right-[28.96%] bottom-[39.79%] left-[29.17%] max-w-full overflow-hidden max-h-full"
                alt=""
                src="Vector.svg"
              />
            </div>
          </div>
          <div className="w-[204px] flex flex-row items-center justify-start gap-0.5">
            <div className="rounded-lg bg-neutrals-white-light flex flex-row items-center justify-start p-1.5">
              <div className="w-5 relative h-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4.88 4.5c0-1.1.9-2 2-2H12c2.62 0 4.75 2.13 4.75 4.75S14.62 12 12 12H4.88V4.5ZM4.88 12h9.5c2.62 0 4.75 2.13 4.75 4.75S17 21.5 14.38 21.5h-7.5c-1.1 0-2-.9-2-2V12v0Z"
                    stroke="#2d404e"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="rounded-lg bg-white flex flex-row items-center justify-start p-1.5">
              <div className="w-5 relative h-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.62 3h9.25M5.12 21h9.25M14.25 3l-4.5 18"
                    stroke="#576e7e"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="rounded-lg bg-white flex flex-row items-center justify-start p-1.5">
              <div className="w-5 relative h-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M5 21h14M5 3v7c0 3.87 3.13 7 7 7s7-3.13 7-7V3"
                    stroke="#576e7e"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="flex-1 relative border-neutrals-neutral-100 border-solid border-r-[1px] box-border h-[21px]" />
            <div className="rounded-lg bg-white flex flex-row items-center justify-start p-1.5">
              <div className="w-5 relative h-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M3 4.5h18M3 9.5h9.47M3 14.5h18M3 19.5h9.47"
                    stroke="#576e7e"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="rounded-lg bg-white flex flex-row items-center justify-start p-1.5">
              <div className="w-5 relative h-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M3 4.5h18M7.26 9.5h9.48M3 14.5h18M7.26 19.5h9.48"
                    stroke="#576e7e"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="rounded-lg bg-white flex flex-row items-center justify-start p-1.5">
              <div className="w-5 relative h-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M3 4.5h18M11.53 9.5H21M3 14.5h18M11.53 19.5H21"
                    stroke="#576e7e"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-xl bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border min-h-[220px] flex flex-row items-start justify-start p-5 overflow-auto">
          <div
            ref={contentRef}
            className="flex-1 relative whitespace-pre-line outline-none"
            contentEditable
            dangerouslySetInnerHTML={{ __html: content }}
            onInput={handleContentChange}
          />
        </div>
      </div>
      </div>
      <div className="w-[648px] flex flex-row items-center justify-end pt-8 px-6 pb-6 box-border gap-3 text-sm">
        <CTAs
          type="Ghostbtn"
          text="Cancel"
          textColor="text-neutrals-neutral-900"
          bgColor="bg-neutrals-neutral-50"
          borderColor="border-neutrals-neutral-100"
          position="relative"
          onClick={onClose}
        />

        <CTAs
          type="Primarybtn"
          text="Save changes"
          textColor="text-neutrals-neutral-50"
          bgColor="bg-primary-primary-500"
          borderColor="border-primary-primary-500"
          position="relative"
          onClick={handleSave}
        />
      </div>
    </div>
  );
};

InvoiceReminderTemplate.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onContentChange: PropTypes.func,
   onSave: PropTypes.func,
  initialContent: PropTypes.string,
};

export default InvoiceReminderTemplate;